import React, { PureComponent } from 'react';

import {
  Undo as ActionUndo,
  Save as ActionSave,
  PermContactCalendar as PermContactIcon,
} from '@mui/icons-material';

import {
  Table,
  TableBody,
  TableHead,
  TableCell,
  TableRow,
  TextField,
  MenuItem,
  Tooltip,
  Zoom,
  IconButton,
} from '@mui/material';

import Tile from '../../../../common/components/Tile/Tile';

class SettingsManager extends PureComponent {
  render() {
    return (
      <Tile
        title="User settings"
        TitleIcon={PermContactIcon}
        helpTag="user_settings"
        data-qa="qa-user-settings-table"
      >
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>No</TableCell>
              <TableCell>Setting key</TableCell>
              <TableCell>Setting value</TableCell>
              <TableCell>Description</TableCell>
              <TableCell>Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {this.props.dataContent.map((el, index) => (
              <TableRow key={el.UserSettingId}>
                <TableCell>{index + 1}</TableCell>
                <TableCell>{el.Key}</TableCell>
                <TableCell style={{ width: '35%', minWidth: '10rem' }}>
                  {this.props.config.find(
                    (conf) => conf.Key == el.Key && conf.Type == 'dropdown'
                  ) != undefined ? (
                    <TextField
                      variant="standard"
                      select={true}
                      value={el.Value}
                      onChange={(event) =>
                        this.props.onModifyCallback('Value', event.target.value, el, index)
                      }
                      data-qa="qa-value-select-dropdown"
                      style={{ width: '100%' }}
                      margin="normal"
                    >
                      {this.props.config
                        .find((conf) => conf.Key == el.Key)
                        .Values.map((config) => (
                          <MenuItem key={config + index} value={config}>
                            {`${config}`}
                          </MenuItem>
                        ))}
                    </TextField>
                  ) : (
                    <TextField
                      variant="standard"
                      placeholder="The Value"
                      value={el.Value}
                      multiline
                      minRows={1}
                      maxRows={5}
                      onChange={(event) => {
                        this.props.onModifyCallback('Value', event.target.value, el, index);
                      }}
                      data-qa="qa-value-select-dropdown"
                      style={{ width: '100%' }}
                    />
                  )}
                </TableCell>
                <TableCell>{el.Description}</TableCell>
                <TableCell>
                  {this.isModified(index) ? (
                    <Tooltip disableInteractive TransitionComponent={Zoom} title="Save">
                      <IconButton
                        size="large"
                        style={{}}
                        onClick={() => {
                          this.props.onSaveCallback(index);
                        }}
                        data-qa="qa-save"
                      >
                        <ActionSave />
                      </IconButton>
                    </Tooltip>
                  ) : (
                    <Tooltip
                      disableInteractive
                      TransitionComponent={Zoom}
                      title="Revert to default"
                    >
                      <IconButton
                        size="large"
                        style={{}}
                        onClick={() => {
                          this.props.onResetCallBack(index);
                        }}
                        data-qa="qa-revert-to-default"
                      >
                        <ActionUndo />
                      </IconButton>
                    </Tooltip>
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Tile>
    );
  }

  isModified = (index) => {
    return this.props.modifiedRowsContent.indexOf(index) !== -1;
  };
}

export default SettingsManager;
